import React, { useState, useEffect } from 'react';
import NavbarAdmin from './NavbarAdmin';
import { toast, ToastContainer } from 'react-toastify';
import { endpoints } from '../config/apiConfig';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import Swal from 'sweetalert2';

const GestionUsuarios = () => {
  const [usuarios, setUsuarios] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [globalFilter, setGlobalFilter] = useState(''); // Add this line
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    password: '',
    cedula: '',
    rol: '',
    programa_id: ''
  });

  const resetForm = () => {
    setFormData({
      nombre: '',
      email: '',
      password: '',
      cedula: '',
      rol: '',
      programa_id: ''
    });
    setEditingUser(null);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const fetchUsuarios = async () => {
    try {
      const response = await fetch(endpoints.usuarios.listar, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      if (!response.ok) throw new Error('Error al cargar usuarios');
      const data = await response.json();
      
      // Check if data is an array or has a users property
      if (Array.isArray(data)) {
        setUsuarios(data);
      } else if (data.users && Array.isArray(data.users)) {
        setUsuarios(data.users);
      } else {
        console.error('Formato de respuesta inválido:', data);
        setUsuarios([]);
        toast.error('Error en el formato de datos');
      }
    } catch (error) {
      console.error('Error al cargar usuarios:', error);
      setUsuarios([]);
      toast.error('Error al cargar usuarios');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const endpoint = editingUser 
        ? endpoints.usuarios.actualizar(editingUser.id)
        : endpoints.usuarios.crear;
      
      const method = editingUser ? 'PUT' : 'POST';

      const userData = {
        nombre: formData.nombre,
        email: formData.email,
        cedula: formData.cedula,
        password: formData.password,
        rol_id: parseInt(formData.rol),
        programa_id: formData.programa_id
      };

      if (editingUser) {
        delete userData.password;
      }

      console.log('Endpoint:', endpoint);
      console.log('Datos a enviar:', userData);

      const response = await fetch(endpoint, {
        method,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify(userData)
      });

      const responseData = await response.json();
      console.log('Respuesta del servidor:', responseData);

      if (!response.ok) {
        const errorMessage = responseData.message || responseData.error || 'Error en la operación';
        throw new Error(errorMessage);
      }

      toast.success(editingUser ? 'Usuario actualizado' : 'Usuario creado exitosamente');
      setModalOpen(false);
      resetForm();
      fetchUsuarios();
    } catch (error) {
      console.error('Error detallado:', error);
      toast.error(error.message || 'Error al procesar la solicitud');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: '¿Está seguro?',
      text: "No podrá revertir esta acción",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#262626',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    });

    if (result.isConfirmed) {
      try {
        const response = await fetch(endpoints.usuarios.eliminar(id), {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });

        if (!response.ok) throw new Error('Error al eliminar');

        Swal.fire(
          '¡Eliminado!',
          'El usuario ha sido eliminado.',
          'success'
        );
        fetchUsuarios();
      } catch (error) {
        Swal.fire(
          'Error',
          'No se pudo eliminar el usuario.',
          'error'
        );
      }
    }
  };

  // Add roles state
  const [roles, setRoles] = useState([]);
  
  // Add fetchRoles function
  const fetchRoles = async () => {
    try {
      const response = await fetch(endpoints.roles, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      if (!response.ok) throw new Error('Error al cargar roles');
      const data = await response.json();
      if (data.status === 'success' && Array.isArray(data.roles)) {
        setRoles(data.roles);
      }
    } catch (error) {
      console.error('Error al cargar roles:', error);
      toast.error('Error al cargar roles');
    }
  };
  

  // Agregar después de const [roles, setRoles] = useState([]);
  const [programas, setProgramas] = useState([]);
  
  // Agregar después de fetchRoles
  const fetchProgramas = async () => {
    try {
      const response = await fetch(endpoints.programas, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      if (!response.ok) throw new Error('Error al cargar programas');
      const data = await response.json();
      
      // Verificar la estructura de la respuesta
      if (Array.isArray(data)) {
        setProgramas(data);
      } else if (data.programas && Array.isArray(data.programas)) {
        setProgramas(data.programas);
      } else {
        console.error('Formato de respuesta inválido:', data);
        setProgramas([]);
        toast.error('Error en el formato de datos de programas');
      }
    } catch (error) {
      console.error('Error al cargar programas:', error);
      setProgramas([]);
      toast.error('Error al cargar programas');
    }
  };

  // Modificar useEffect para incluir fetchProgramas
  useEffect(() => {
    fetchUsuarios();
    fetchRoles();
    fetchProgramas();
  }, []);

  // Replace the programa_id input with this select */}
                  <div>
                    <label className="text-left block text-sm font-medium text-gray-700">Programa</label>
                    <select
                      name="programa_id"
                      value={formData.programa_id}
                      onChange={handleInputChange}
                      className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                      required={formData.rol !== '1'}
                    >
                      <option value="">Seleccione un programa</option>
                      {programas.map(programa => (
                        <option key={programa.id} value={programa.id}>
                          {programa.nombre}
                        </option>
                      ))}
                    </select>
                  </div>

  const roleBodyTemplate = (rowData) => {
    const role = roles.find(r => r.id === parseInt(rowData.rol_id));
    return role ? role.nombre : rowData.rol_id;
  };

  return (
    <>
      <NavbarAdmin />
      <div className="container mx-auto px-4 py-8">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold p-5">Gestión de Usuarios</h1>
          <Button
            label="Nuevo Usuario"
            icon="pi pi-plus"
            onClick={() => {
              resetForm();
              setModalOpen(true);
            }}
            className="bg-gray-200  hover:bg-neutral-300 p-1 mr-12"
          />
        </div>

        <div className="card">
          <div className="flex justify-end mb-4">
            <span className="p-input-icon-left">
              <InputText
                value={globalFilter}
                onChange={(e) => setGlobalFilter(e.target.value)}
                placeholder="Buscar..."
                className="p-inputtext p-component p-filled border rounded mr-12"
              />
            </span>
          </div>
          <DataTable
            value={usuarios}
            paginator
            rows={50}
            rowsPerPageOptions={[5, 10, 25, 50, 100]}
            dataKey="id"
            globalFilter={globalFilter}
            emptyMessage="No se encontraron usuarios"
            className="p-datatable-striped"
          >
            <Column
              field="nombre"
              header="Nombre"
              sortable
              filterPlaceholder="Buscar por nombre"
            />
            <Column
              field="email"
              header="Email"
              sortable
              filterPlaceholder="Buscar por email"
            />
            <Column
              field="rol_id"
              header="Rol"
              sortable
              body={roleBodyTemplate}
            />
            <Column
              field="programa_id"
              header="Programa"
              sortable
              filter
              filterPlaceholder="Buscar por programa"
            />
            <Column
              header="Acciones"
              body={(rowData) => (
                <div className="flex gap-2">
                  <Button
                    icon="pi pi-pencil"
                    className="p-button-rounded p-button-warning"
                    onClick={() => {
                      setEditingUser(rowData);
                      setFormData({
                        nombre: rowData.nombre || '',
                        email: rowData.email || '',
                        cedula: rowData.cedula || '',
                        rol: rowData.rol_id ? rowData.rol_id.toString() : '',
                        programa_id: rowData.programa_id ? rowData.programa_id.toString() : ''
                      });
                      setModalOpen(true);
                    }}
                  />
                  <Button
                    icon="pi pi-trash"
                    className="p-button-rounded p-button-danger"
                    onClick={() => handleDelete(rowData.id)}
                  />
                </div>
              )}
              exportable={false}
              style={{ minWidth: '8rem' }}
            />
          </DataTable>

          {/* Modal Form */}
          {modalOpen && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4">
              <div className="bg-white rounded-lg p-8 max-w-md w-full">
                <h2 className="text-left text-xl font-bold mb-4">
                  {editingUser ? 'Editar Usuario' : 'Crear Nuevo Usuario'}
                </h2>
                <form onSubmit={handleSubmit} className="space-y-4">
                  <div>
                    <label className="text-left block text-sm font-medium text-gray-700">Nombre</label>
                    <input
                      type="text"
                      name="nombre"
                      value={formData.nombre}
                      onChange={handleInputChange}
                      className="mt-1 block p-inputtext p-1 border-gray-300 shadow-sm p-component p-filled border rounded w-full"
                      required
                    />
                  </div>
                  <div>
                    <label className="text-left block text-sm font-medium text-gray-700">Email</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      className="mt-1 block p-inputtext p-1 border-gray-300 shadow-sm p-component p-filled border rounded w-full"
                      required
                    />
                  </div>
                  <div>
                    <label className="text-left block text-sm font-medium text-gray-700">Cédula</label>
                    <input
                      type="text"
                      name="cedula"
                      value={formData.cedula}
                      onChange={handleInputChange}
                      className="mt-1 block p-inputtext p-1 border-gray-300 shadow-sm p-component p-filled border rounded w-full"
                      required
                    />
                  </div>
                  {!editingUser && (
                    <div>
                      <label className="text-left block text-sm font-medium text-gray-700">Contraseña</label>
                      <input
                        type="password"
                        name="password"
                        value={formData.password}
                        onChange={handleInputChange}
                        className="mt-1 block p-inputtext p-1 border-gray-300 shadow-sm p-component p-filled border rounded w-full"
                        required={!editingUser}
                      />
                    </div>
                  )}
                  <div>
                    <label className="text-left block text-sm font-medium text-gray-700">Rol</label>
                    <select
                      name="rol"
                      value={formData.rol}
                      onChange={handleInputChange}
                      className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                      required
                    >
                      <option value="">Seleccione un rol</option>
                      {roles.map(rol => (
                        <option key={rol.id} value={rol.id}>
                          {rol.nombre}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label className="text-left block text-sm font-medium text-gray-700">Programa</label>
                    <input
                      type="text"
                      name="programa_id"
                      value={formData.programa_id}
                      onChange={handleInputChange}
                      className="mt-1 block p-inputtext p-1 border-gray-300 shadow-sm p-component p-filled border rounded w-full"
                      required
                    />
                  </div>
                  <div className="flex justify-end space-x-2 mt-6">
                    <button
                      type="button"
                      onClick={() => {
                        setModalOpen(false);
                        resetForm();
                      }}
                      className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
                    >
                      Cancelar
                    </button>
                    <button
                      type="submit"
                      disabled={loading}
                      className="px-4 py-2 bg-neutral-900 text-white rounded-md hover:bg-neutral-800 disabled:bg-gray-400"
                    >
                      {loading ? 'Guardando...' : 'Guardar'}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>
      </div>
      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
};

export default GestionUsuarios;